import { orderTypeCode } from '@/constants/global';
export default class MapStore {
    storeId;
    _items;
    position;
    isShareStore;
    delayedOrderIds;
    constructor(order) {
        this.storeId = null;
        this._items = {};
        this.position = [];
        this.isShareStore = null;
        // 지연건 주문 번호
        this.delayedOrderIds = new Set();
        if (order) {
            this.init(order);
        }
    }
    get items() {
        return this._items;
    }
    set items(order) {
        this._items[order.orderId] = order;
    }
    get storeName() {
        return this._items[Object.keys(this._items)[0]].storeName;
    }
    get hasItems() {
        return !!Object.keys(this._items).length;
    }
    /**
     * 도착지 벌크 업데이트
     * @param items
     */
    bulkInsertItems(items) {
        this._items = items;
    }
    /**
     * 스토어 정보 셋팅
     * @param order
     */
    init(order) {
        this.storeId = order.typeCode === orderTypeCode.QUICK ? orderTypeCode.QUICK : order.storeId;
        this.position = [
            order.pickupLatitude,
            order.pickupLongitude,
        ];
        this.isShareStore = order.isShareOrder;
    }
    /**
     * 주문 추가
     * @param order
     */
    addOrder(order) {
        this._items[order.orderId] = order;
    }
    /**
     * 주문 제거
     * @param {string} orderId
     */
    deleteOrder(orderId) {
        return delete this._items[orderId];
    }
}
